import styled from 'styled-components';
import { Swiper } from 'swiper/react';

export const Wrapper = styled.div`
  position: relative;
`;

export const PreviousElement = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(calc(-50% - 7px));
  left: -20px;
  cursor: pointer;
`;
export const NextElement = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(calc(-50% - 7px));
  right: -20px;
  cursor: pointer;
`;

export const StyledSwiper = styled(Swiper)`
  padding-bottom: 20px;

  & .swiper-button-next,
  & .swiper-button-prev {
    color: ${({ theme }) => theme.palette.darkGrey};
    width: 50px;
    height: 50px;
    ::after {
      font-size: 22px;
    }
  }
`;
